import { Routes, Route } from 'react-router-dom';
import Home from '../../Pages/users/Home';
import { useAuth } from '../../Services/AuthContext';
import UserHeader from '../Headers/userHeader';
import useAutoAlerteSonore from '../../Services/Alert';

const UserLayout = () => {
  const { user } = useAuth();
  const isAdmin = !!user?.roles.includes("ROLE_ADMIN");
  const isMagasin = !!user?.roles.includes("ROLE_MAGASIN");
  const isMagasinLoin = !!user?.roles.includes("ROLE_MAGASIN_LOIN");
useAutoAlerteSonore()
  return (
    <>
      <UserHeader isAdmin={isAdmin} isMagasin={isMagasin} isMagasinLoin={isMagasinLoin} />
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </>
  );
};

export default UserLayout;
